import {IonIcon, IonList} from "@ionic/react";
import {Link} from "react-router-dom";

//
import "../../../components/CategoriesPopover/categories.styles.css";
import React, {useEffect, useRef} from "react";

//
interface IServiceList {
  items: any[];
  category: string;
  onCustomQuote: any;
}

//
const ServiceList = ({items, category, onCustomQuote}: IServiceList) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  // const licenseServices: string[] = [
  //   "licenseRenewal",
  //   "nauticalLicenseRenewal",
  // ];

  // const ownershipServices: string[] = [
  //   "mopedOwnershipTransfer",
  //   "vehicleOwnershipTransfer",
  //   "motorVehicleOwnershipTransfer",
  // ];

  // const registrationServices: string[] = [
  //   "mopedRegistration",
  //   "foreignVehicleRegistration",
  // ];

  const servicesToRemove: string[] = [
    // ...licenseServices,
    // ...ownershipServices,
    // ...registrationServices,
  ];

  const filteredItems = items.filter(
    (item: any) => !servicesToRemove.includes(item.serviceType)
  );

  //
  // const specialItems = [
  //   {
  //     title: "Rinnovo patenti",
  //     category: "auto",
  //     path: "/preventivo/special/license-renewal",
  //   },
  //   {
  //     title: "Passaggio di proprietà",
  //     category: "auto",
  //     path: "/preventivo/special/ownership-transfer",
  //   },
  //   {
  //     title: "Immatricolazione veicoli esteri",
  //     category: "auto",
  //     path: "/preventivo/special/vehicle-registration",
  //   },
  // ];

  const [searchText, setSearchText] = React.useState("");

  useEffect(() => {
    inputRef?.current?.focus?.();
  }, []);

  //
  return (
    <IonList className="categories-services-list">
      <div
        className="searchable-select-input"
        style={{
          marginBottom: "1rem",
        }}
      >
        <input
          type="text"
          id="search-text"
          className="navbar-search navbar-search-mobile"
          placeholder="Cerca un servizio"
          defaultValue={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          autoFocus
          tabIndex={0}
        />
        <IonIcon name="search-outline" className="input-search-icon" />
      </div>
      {filteredItems
        .sort((a, b) => (a.order < b.order ? -1 : 0))
        .filter((item) =>
          item.name.toLowerCase().includes(searchText.toLowerCase())
        )
        .map((item: any, index: number) => (
          <Link
            to={{
              pathname: `/preventivo/details/${item.id}`,
              state: {
                categoryName: category,
                serviceName: item.name,
              },
            }}
            key={index}
          >
            <li className="categories-services-items">
              <span>{item.name}</span>
            </li>
          </Link>
        ))}

      {/* {specialItems
        .filter((item) => item.category === category)

        .map((item) => (
          <Link to={item.path} key={item.path}>
            <li className="categories-services-items">
              <span>{item.title}</span>
            </li>
          </Link>
        ))} */}

      <li
        className="categories-services-items categories-services-items-notFound"
        onClick={onCustomQuote}
      >
        Non hai trovato il servizio che cercavi, scrivici!
      </li>
    </IonList>
  );
};

export default ServiceList;
